import * as consts from 'config/consts';
import { getSign, Sign } from '../new-report/utils/formatter';
import { isNotExistDetailTypes } from './productTypes';

export type AmountColor = 'text-upcolor' | 'text-downcolor' | '';

export const amountToAmountColor = (value: number): AmountColor => {
  if (value === 0) return '';

  const signToAmountColor = (sign: Sign): AmountColor => {
    if (sign === 'minus') return 'text-downcolor';
    return 'text-upcolor';
  };
  return signToAmountColor(getSign(value));
};

export const arrangeDateForChart = (date: Date): Date => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 9);
};

export const isSymbolEmpty = (symbol: string | null): boolean => {
  return symbol === null || symbol === '';
};

export const isGoSymbolDetail = (symbol: string, productType: number) => {
  return (
    !isNotExistDetailTypes(productType) &&
    !isSymbolEmpty(symbol) &&
    !(
      productType === consts.productTypes.投資信託 &&
      (symbol === '' || /^DC/.test(symbol) || /^MONO/.test(symbol))
    )
  );
};
